import { render, staticRenderFns } from "./ArticlePreview.vue?vue&type=template&id=1920e7be&"
import script from "./ArticlePreview.vue?vue&type=script&lang=js&"
export * from "./ArticlePreview.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePreview.vue?vue&type=style&index=0&id=1920e7be&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports